import React, { useState } from 'react';
import { Upload } from 'antd';
import { Button, Dialog, Message } from '@alifd/next';
import { TiUpload } from 'react-icons/ti';
import { Box, Typography } from '@mui/material';
import axios from 'axios';

export default function UploadExcelButton({
  dbName = '',
  func = {},
  setIsUpdate = () => {},
}) {
  const [visible, setVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileError, setFileError] = useState(false);

  const handleUpload = async () => {
    if (fileList.length > 0) {
      const formData = new FormData();
      formData.append('files', fileList[0]);
      try {
        await axios(`/ezcon/api/uploadDynamicMenuExcel?type=${dbName}`, {
          method: 'POST',
          headers: { authorization: window.localStorage['feathers-jwt'] },
          data: formData,
        });
        Message.success('上傳成功');
        setIsUpdate(true);
        setVisible(false);
      } catch (e) {
        console.log(e);
        Message.error('上傳失敗');
      }
    }
  };

  console.log({ fileList });
  return (
    <>
      <Button onClick={() => setVisible(true)}>{func.text}</Button>
      <Dialog
        visible={visible}
        onClose={() => {
          setVisible(false);
          setFileList([]);
          setFileError(false);
        }}
        footer={false}
        title={func.text}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Upload.Dragger
            name="file"
            multiple={false}
            beforeUpload={(file) => {
              // 檢查檔案類型與大小
              console.log({ file });
              const isExcel =
                file.type ===
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              const isLt20M = file.size / 1024 / 1024 < 20;
              if (isExcel && isLt20M) {
                setFileError(false);
                setFileList([file]);
                return false;
              } else {
                setFileError(true);
                setFileList([]);
                return false;
              }
            }}
            fileList={fileList}
            onRemove={() => setFileList([])}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: 368,
                width: 400,
              }}
            >
              <TiUpload size={50} />
              <Typography variant="body2">
                點擊上傳檔案或拖拽檔案到此處
              </Typography>
              <Typography variant="body2">
                檔案格式為xlsx，大小不超過20MB
              </Typography>
              <Typography variant="body2" color="error">
                {fileError && '檔案格式錯誤或大小超過20MB'}
              </Typography>
            </Box>
          </Upload.Dragger>
          <Button
            onClick={handleUpload}
            style={{
              width: '100%',
            }}
            disabled={fileList.length === 0}
          >
            上傳
          </Button>
        </Box>
      </Dialog>
    </>
  );
}
